import {StyleSheet} from 'react-native';

const styles = StyleSheet.create({
  mainView: {
    height: '100%',
    justifyContent: 'space-evenly',
  },
  leftButton: {
    flex: 1,
  },
  rightButton: {
    flex: 1,
    marginLeft: 16,
  },
  buttonsContainer: {
    flexDirection: 'row',
    margin: 16,
    paddingBottom: 16,
  },
  flex1: {
    flex: 1,
  },
});

export default styles;
